class RecipeDetailExportOptionsController {

    constructor(dialogRegistry, moveFocus, analyticsService) {
        this.dialogRegistry = dialogRegistry;
        this.moveFocus = moveFocus;
        this.analyticsService = analyticsService;

        this.showPrintOption = this.enablePrint === undefined || this.enablePrint;
        this.showEmailOption = this.enableEmail === undefined || this.enableEmail;
    }

    emailRecipe() {
        const emailDialog = this.dialogRegistry.getDialog('email recipe');
        if (emailDialog) {
            emailDialog.show();
            this.moveFocus('#emailForm-recipientEmail');
        }
        this.analyticsService.pushEvent(this.analyticsService.eventsDtm.EMAIL_SHARE);
    }

    logPrintRecipeClick() {
        this.analyticsService.pushEvent(this.analyticsService.eventsDtm.PRINT_RECIPE);
    }
}

const recipeDetailExportOptionsComponentDefinition = {
    bindings: {
        recipeId: '@',
        enablePrint: '=?',
        enableEmail: '=?',
    },
    controller: ['DialogRegistry', 'MoveFocus', 'AnalyticsService', RecipeDetailExportOptionsController],
    template: require('./recipe-detail-export-options.component.html').trim(),
};

module.exports = {
    RecipeDetailExportOptionsController,
    recipeDetailExportOptionsComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/recipe/recipedetail/recipe-detail-export-options.component.js